module.exports = __webpack_public_path__ + "img/9_41.d98aa509.png";